import React, { useState } from "react";
import { FALLBACK_ICON } from "@/utils/constants";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
  loading?: "lazy";
}

const Image: React.FC<ImageProps> = ({
  width,
  height,
  src,
  alt,
  className,
  loading,
  fallbackSrc,
  ...props
}) => {
  const [imageError, setImageError] = useState(false);

  const handleError = (
    event: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    event.currentTarget.src = fallbackSrc || FALLBACK_ICON;
    setImageError(true);
  };

  return (
    <img
      width={width}
      height={height}
      src={imageError ? fallbackSrc || src : src}
      alt={alt}
      className={className}
      loading={loading}
      onError={handleError}
      {...props}
    />
  );
};

export default Image;
